import React, { useState } from "react";
import SearchBar from "../../reusebale/searchBar";
import db from "../../../db/index.json";
import FilterPopup from "../../popup/filterPopup";
import SupportShift from "../support-staff/shift";
import SupportStaff from "../support-staff/staff";
import CreateSupport from "./create-support/createMain"
import DetailStaffMain from './detail-staff/detailStaffMain'

const SupportMain = () => {
  const { support } = db;
  const [showTable, setShowTable] = useState("table");
  const [showFilter, setShowFilter] = useState(false);

  const [selectedStaff, setSelectedStaff] = useState()

  const openPopup = () => {
    setShowFilter(true);
  };

  const closePopup = () => {
    setShowFilter(false);
  };

  const toggleDetail = (item) => {
    setSelectedStaff(item)
    setShowTable("detail");
  };

  const toggleCreate = (item) => {
    setShowTable("create"); // State toggle karein
  };

  const toggleTable = () => {
    setShowTable("table"); // State toggle karein
  };

  return (
    <div className="">
      {/* <SearchBar title={maintainances.title} desc={maintainances.description} onSubmit={openPopup}/>
      <LeaseTable /> */}
      {(() => {
        switch (showTable) {
          case "table":
            return (
              <div className="h-screen w-full">
                <div className="h-[10vh]">
                  <SearchBar
                    title={support.heading}
                    desc={support.renew}
                    onSubmit={openPopup}
                  />
                </div>
                <div className="h-[90vh]">
                  <div className="flex flex-col justify-between h-full">
                    <div className="h-[59%]">
                      <SupportStaff createSupport={toggleCreate} detailStaff={toggleDetail} />
                    </div>
                    <div className="h-[40%]">
                      <SupportShift />
                    </div>
                  </div>
                </div>
              </div>
            );
          case "create":
            return <CreateSupport onBack={toggleTable} />;
          case "detail":
            return <DetailStaffMain selectedStaff={selectedStaff} onBack={toggleTable} />;
          default:
            break;
        }
      })()}
      {showFilter && <FilterPopup onBack={closePopup} onFilter={closePopup} />}
    </div>
  );
};

export default SupportMain;
